import { Component, OnInit } from '@angular/core';

import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer} from '@angular/platform-browser';
import { prefillHostVars } from '@angular/core/src/render3/instructions';
import { GlobalsService } from '../common/services/globals.service';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}
  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
} 

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.css']
})
export class TermsAndConditionsComponent implements OnInit {

  get TCLink() {
    if (GlobalsService.language == null || GlobalsService.language == '' || GlobalsService.language == 'EN') {
      return "../../../billing/paynow/assets/ePAY_T&C.pdf";
    } else if(GlobalsService.language == 'ES') {
       if(GlobalsService.partner === 'AHNJ') {
        return "../../../billing/paynow/assets/ES_ePAY_T&C.pdf";
      }
    }
  }

  termsURL = '/billing/paynow/assets/' + GlobalsService.partner + '_terms_conditions.pdf';

  constructor() { }

  get partner() {
    return GlobalsService.partner;
  }

  get partnerEbillLogo() {
    return "/billing/paynow/assets/img/" + GlobalsService.partner + "_EBILL_Logo.png";
  }

  ngOnInit() {
  }

}
